import { Reducer } from "redux";

import { AddPortalUpdateResponse } from "../models/api/Admin";
import { AddPortalUpdateActionDispatchTypes } from "../constants/Admin";
import { PostAddPortalUpdateDispatchTypes } from "../models/dispatchTypes/Admin";

const initialState: AddPortalUpdateResponse = {
  loading: false,
  response: {
    userId: "",
    updateText: "",
    userCreated: "",
    dateCreated: ""
  },
  error: null,
};

const PostAddPortalUpdateReducer: Reducer<
  AddPortalUpdateResponse,
  PostAddPortalUpdateDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case AddPortalUpdateActionDispatchTypes.POST_ADD_PORTAL_UPDATE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case AddPortalUpdateActionDispatchTypes.POST_ADD_PORTAL_UPDATE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case AddPortalUpdateActionDispatchTypes.POST_ADD_PORTAL_UPDATE_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
  }
  return state;
};

export default PostAddPortalUpdateReducer;
